export const legacyPackageCategories = [
  { value: "general_wellness", label: "General Wellness" },
  { value: "cardiac_screening", label: "Cardiac Screening" },
  { value: "womens_health", label: "Women’s Health" },
  { value: "mens_health", label: "Men’s Health" },
  { value: "pre_marital_screening", label: "Pre-Marital Screening" },
  { value: "vaccination", label: "Vaccination" },
];

export const packageCategories = [
  { value: "health_screening", label: "Health Screening" },
  { value: "general_wellness", label: "General Wellness" },
  { value: "vaccination", label: "Vaccination" },
  { value: "advanced_cardiac_packages", label: "Advanced Cardiac Packages" },
];

export { packageTypes, packageStatuses } from "../../helpers/helpers";

export function displayCategory(category) {
  if (category && typeof category === "object") return category.name || category.label || "";
  return packageCategories.find(item => String(item.value) === String(category))?.label || category || "";
}

export function displayStatus(status) {
  if (status === 1 || status === "1" || status === true) return "published";
  if (status === 0 || status === "0" || status === false) return "draft";
  if (status === "active") return "published";
  if (status === "inactive") return "archived";
  return String(status || "draft").toLowerCase();
}

export function currency(value) {
  if (value === null || value === undefined || value === "") return "-";
  const number = Number(value);
  return Number.isFinite(number) ? `RM ${number.toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "-";
}
